import Bg_3Grid from './BG_3Grid';
import Bg_6Grid from './BG_6Grid';
import Main_3Grid from './Main_3Grid';
import Main_3_5Grid from './Main_3_5Grid';
import Main_2Grid from './Main_2Grid';

export { Bg_3Grid, Bg_6Grid, Main_3Grid, Main_3_5Grid, Main_2Grid };



// WEBPACK FOOTER //
// ./src/pubBiz/CommonCell/ClassifyCell/components/index.js